import { render } from "./ActsBindingButton.vue?vue&type=template&id=dc02e590"
import script from "./ActsBindingButton.vue?vue&type=script&lang=js"
export * from "./ActsBindingButton.vue?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__